import { render, staticRenderFns } from "./ManageSettlementsInDefaultEmail.vue?vue&type=template&id=25675415&scoped=true"
import script from "./ManageSettlementsInDefaultEmail.vue?vue&type=script&lang=js"
export * from "./ManageSettlementsInDefaultEmail.vue?vue&type=script&lang=js"
import style0 from "./ManageSettlementsInDefaultEmail.vue?vue&type=style&index=0&id=25675415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25675415",
  null
  
)

export default component.exports